import script from "./kf.vue?vue&type=script&setup=true&lang=js"
export * from "./kf.vue?vue&type=script&setup=true&lang=js"

import "./kf.vue?vue&type=style&index=0&id=5d7b6bbe&lang=less"

const __exports__ = script;

export default __exports__